/*
 * Copyright (c) 2022. Nedaware SL
 */

/**
 * Nedaware S.L.
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */
import {ValidatorFn} from "@angular/forms";
import {Caster} from "../casters/caster";
import {NestedModelTypeInterface} from "./nested-model-type";
import {ChoiceTypeInterface, DecimalTypeInterface, DictionaryTypeInterface, PatternTypeInterface, RangeTypeInterface, TypeWithLengthInterface, UriTypeInterface} from "./property-type";
import {TypeStr} from "./type-str";
import {ObjectType} from "./object-type";

/**
 * Interface for the types that are applicable to the properties in the mapping
 *
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */
export abstract class PropertyTypeInterface {
    abstract readonly validators: ValidatorFn[] | ValidatorFn | null;

    public readonly expectedApiTypes: string[] = [];

    abstract toString(): TypeStr;

    public stringCaster: Caster<any, string> | null = null;

    public asChoice(): ChoiceTypeInterface {
        throw new Error('asChoice on a non-choice type. Please check the TypeStr.');
    }

    public asRange(): RangeTypeInterface {
        throw new Error('asRange on a non-range type. Please check the TypeStr.');
    }

    public asDecimal(): DecimalTypeInterface {
        throw new Error('asDecimal on a non-decimal type. Please check the TypeStr.');
    }

    public asUri(): UriTypeInterface {
        throw new Error('asUri on a non-uri type. Please check the TypeStr.');
    }

    public asNestedModel(): NestedModelTypeInterface<any> {
        throw new Error('asNestedModel on a non-nested type. Please check the TypeStr.');
    }

    public asPattern(): PatternTypeInterface {
        throw new Error('asPattern on a non-email type. Please check the TypeStr.');
    }

    public asWithLength(): TypeWithLengthInterface {
        throw new Error('asWithLength on a non-lengthy type. Please check the TypeStr.');
    }

    public asDictionary(): DictionaryTypeInterface {
        throw new Error('asDictionary on a non-dictionary type. Please check the TypeStr.');
    }

    public asObject(): ObjectType {
        throw new Error('asObject on a non-object type. Please check the TypeStr.');
    }
}
